"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var createMockResponse = function (url, mockData) {
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve({
            data: mockData,
            status: 200,
            statusText: "OK",
            headers: {},
            config: {},
            request: { url: url }
        }); }, Math.round((Math.random() * 2)) * 1000 + 100);
    });
};
var parseAndReplacePathParams = function (url, pathParams) {
    var urlPathParams = url.match(/{{[^{}]+}}/g);
    if (urlPathParams) {
        if (!pathParams || typeof pathParams !== "object") {
            throw new Error("API.get URL " + url + " expects pathParams: { [string]: string } in config object, but received none");
        }
        return urlPathParams.reduce(function (_url, param) {
            var keyname = param.replace(/[{}]/g, '');
            if (!pathParams.hasOwnProperty(keyname)) {
                throw new Error("API.get URL " + url + " expects pathParam " + param + " but did not receive a value in config.pathParams");
            }
            return _url.replace(param, pathParams[keyname]);
        }, url);
    }
    return url;
};
var MesaAPI = (function () {
    function MesaAPI(baseAxioConfig, options) {
        var _a, _b;
        this.isMock = false;
        var axiosInstance = axios_1.default.create(baseAxioConfig);
        if (options) {
            var requestMiddleware = options.requestMiddleware, responseMiddleware = options.responseMiddleware;
            if (typeof requestMiddleware === "function") {
                axiosInstance.interceptors.request.use(requestMiddleware);
            }
            else if (requestMiddleware !== undefined) {
                (_a = axiosInstance.interceptors.request).use.apply(_a, requestMiddleware);
            }
            if (typeof responseMiddleware === "function") {
                axiosInstance.interceptors.response.use(responseMiddleware);
            }
            else if (responseMiddleware !== undefined) {
                (_b = axiosInstance.interceptors.response).use.apply(_b, responseMiddleware);
            }
        }
        this.axiosInstance = axiosInstance;
    }
    MesaAPI.prototype.setAsMock = function () {
        this.isMock = true;
    };
    MesaAPI.prototype.addRequestMiddleware = function (middleware) {
        var _a;
        if (typeof middleware === "function") {
            this.axiosInstance.interceptors.request.use(middleware);
        }
        else if (middleware !== undefined) {
            (_a = this.axiosInstance.interceptors.request).use.apply(_a, middleware);
        }
    };
    MesaAPI.prototype.addResponseMiddleware = function (middleware) {
        var _a;
        if (typeof middleware === "function") {
            this.axiosInstance.interceptors.response.use(middleware);
        }
        else if (middleware !== undefined) {
            (_a = this.axiosInstance.interceptors.response).use.apply(_a, middleware);
        }
    };
    MesaAPI.prototype.handleMockData = function (url, mockData) {
        if (this.isMock) {
            if (mockData === undefined) {
                throw new Error("REACT_APP_MOCK_API=true but mock data not passed for API call " + url);
            }
            return createMockResponse(url, mockData);
        }
    };
    MesaAPI.prototype.get = function (url, config, mockData) {
        var finalUrl = parseAndReplacePathParams(url, config && config.pathParams);
        var mockResult = this.handleMockData(finalUrl, mockData);
        return mockResult === undefined ? this.axiosInstance.get(finalUrl, config) : mockResult;
    };
    MesaAPI.prototype.post = function (url, data, config, mockData) {
        var finalUrl = parseAndReplacePathParams(url, config && config.pathParams);
        var mockResult = this.handleMockData(finalUrl, mockData);
        return mockResult === undefined ? this.axiosInstance.post(finalUrl, data, config) : mockResult;
    };
    MesaAPI.prototype.put = function (url, data, config, mockData) {
        var finalUrl = parseAndReplacePathParams(url, config && config.pathParams);
        var mockResult = this.handleMockData(finalUrl, mockData);
        return mockResult === undefined ? this.axiosInstance.put(finalUrl, data, config) : mockResult;
    };
    MesaAPI.prototype.delete = function (url, config, mockData) {
        var finalUrl = parseAndReplacePathParams(url, config && config.pathParams);
        var mockResult = this.handleMockData(finalUrl, mockData);
        return mockResult === undefined ? this.axiosInstance.delete(finalUrl, config) : mockResult;
    };
    return MesaAPI;
}());
exports.MesaAPI = MesaAPI;
